import React from "react";
import { Colors } from '_styles';
import { StarRating } from '_molecules';

// used for displaying table values in booking list and review list
const TableValue = (props) => {

    if (props.link != undefined) {
        return (
            <p style={{ fontSize: 14, opacity: 0.7, fontWeight: '300', marginLeft: -8, marginTop: 10 }}>
                <a href={props.link} style={{ color: Colors.PRM_LIGHT_BLUE }} target="_blank" rel="noopener noreferrer">
                    {'Trip Image'}
                </a>
            </p>
        )
    }
    if (props.stars) {
        return (
            <div style={{ marginLeft: -28, display: 'flex', alignItems: 'center' }}>
                <StarRating stars={props.title} />
                <p style={{ fontSize: 14, opacity: 0.7, fontWeight: '300', margin: 0, marginLeft: 8, color: Colors.TEXT_COLOR }}>{props.overall ? '(' + props.title + ')' : ''}</p>
            </div>
        )
    }
    if (props.big) {
        return (
            <div style={{ height: 60, textOverflow: 'ellipsis', overflow: 'auto', margin: 0, padding: 0, width: 150, marginLeft: -8, marginTop: 10 }}>
                <p style={{ fontSize: 14, opacity: 0.7, fontWeight: '300', textAlign: 'left', marginTop: 0, color: Colors.TEXT_COLOR }}>{props.title}</p>
            </div>
        )
    }
    else if (props.comment) {
        return (
            <div style={{ height: 60, textOverflow: 'ellipsis', overflow: 'auto', margin: 0, padding: 0, width: 250, marginLeft: -8, marginTop: 10 }}>
                <p style={{ fontSize: 14, opacity: 0.7, fontWeight: '300', textAlign: 'left', marginTop: 0, color: Colors.TEXT_COLOR }}>{props.title}</p>
            </div>
        )
    }
    else {
        return (
            <p style={{ fontSize: 14, opacity: 0.7, fontWeight: '300', textAlign: props.align ? props.align : props.title == 'Assistance' ? 'center' : 'left', marginLeft: props.marginLeft ? props.marginLeft : -8, marginTop: 10, color: props.textColor ? props.textColor : Colors.TEXT_COLOR, }}>{props.title}</p>
        );
    }
}

export default TableValue;
